import { message } from "antd";
import { Component } from "react";

import { showAPIErrorMessage } from "utilities/apiHandler";
import { setLoadingAction } from "utilities/form/form";

import { ApplyLienWaiverPresentational } from "entity/bill/BillList/ApplyLienWaiver/ApplyLienWaiverPresentational";
import { BillListHandler, type IBillListHandler } from "entity/bill/BillList/BillList.api.handler";
import {
    type ApplyLienWaiverResponse,
    type BillListFormActions,
} from "entity/bill/BillList/BillList.api.types";

export interface IApplyLienWaiverProps {
    data: ApplyLienWaiverResponse;
    onClose: () => void;
    actionBeingPerformed: BillListFormActions;
    handler?: IBillListHandler;
}

export type ApplyLienWaiverActions = "apply" | "cancel" | undefined;

interface IApplyLienWaiverState {
    actionBeingPerformed: ApplyLienWaiverActions;
}

export class ApplyLienWaiver extends Component<IApplyLienWaiverProps, IApplyLienWaiverState> {
    state: Readonly<IApplyLienWaiverState> = {
        actionBeingPerformed: undefined,
    };

    static defaultProps = {
        handler: new BillListHandler(),
    };

    private handleApply = async (selectedLienWaiverFormId: number) => {
        await setLoadingAction<ApplyLienWaiverActions>(this, {
            actionBeingPerformed: "apply",
            callback: async () => {
                try {
                    await this.props.handler!.applyLienWaivers(
                        this.props.data.eligibleBills,
                        selectedLienWaiverFormId,
                    );
                    void message.success(`Lien Waivers successfully applied`);
                    this.props.onClose();
                } catch (e) {
                    showAPIErrorMessage(e);
                }
            },
        });
    };

    render() {
        const { onClose, data } = this.props;
        return (
            <ApplyLienWaiverPresentational
                onApply={this.handleApply}
                actionBeingPerformed={this.state.actionBeingPerformed}
                onClose={onClose}
                data={data}
            />
        );
    }
}
